























import { Component, Vue, Prop } from 'vue-property-decorator';
import PaymentMethodShow from '@/components/PaymentMethod/PaymentMethodShow.vue';
import { GQL_paymentMethod_paymentMethod } from '@/queries/__generated__/paymentMethod';

@Component({
  components: {
    PaymentMethodShow,
  },
})
export default class PaymentMethodShowButton extends Vue {
  @Prop() private paymentMethod!: GQL_paymentMethod_paymentMethod;
  private showDialog = false;
}
